import { MeProfile } from '@/core/services/profile/me-profile.model';
import { HomeState } from '@/modules/home/core/state/home.state';
import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'cam-self-registration-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    @if (visible()) {
      <div class="self-reg-banner">
        <div class="self-reg-banner__pill">
          <i class="pi pi-clock"></i>
          <span>{{ remainingLabel() }}</span>
        </div>
        <span class="self-reg-banner__message">{{
          'self_registration.banner_message' | translate
        }}</span>
      </div>
    }
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .self-reg-banner {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 24px;
        margin-left: 64px;
        background: linear-gradient(90deg, #ecfdf5 0%, #f0fdf4 100%);
        border-bottom: 2px solid #6ee7b7;
        border-left: 4px solid #059669;
      }

      .self-reg-banner__pill {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #059669;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        padding: 3px 10px;
        border-radius: 20px;
        white-space: nowrap;
        flex-shrink: 0;

        i {
          font-size: 11px;
        }
      }

      .self-reg-banner__message {
        font-size: 13px;
        font-weight: 500;
        color: #065f46;
        line-height: 1.4;
      }
    `,
  ],
})
export class SelfRegistrationBannerComponent {
  private readonly store = inject(Store);
  private readonly me = this.store.selectSignal<MeProfile>(HomeState.getMe);

  protected visible = computed(() => {
    const profile = this.me();
    return !!(
      profile?.isSelfRegistration && profile?.selfRegistrationExpirationTime
    );
  });

  protected remainingLabel = computed(() => {
    const expirationStr = this.me()?.selfRegistrationExpirationTime;
    if (!expirationStr) return '';

    const now = new Date();
    const expiration = new Date(expirationStr);
    const diffMs = expiration.getTime() - now.getTime();

    if (diffMs <= 0) return '0h restantes';

    const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    if (days > 0) {
      return hours > 0 ? `${days}d ${hours}h restantes` : `${days}d restantes`;
    }
    return `${hours}h restantes`;
  });
}
